import { render, staticRenderFns } from "./SeaLogistic.vue?vue&type=template&id=0f83fd18&"
import script from "./SeaLogistic.vue?vue&type=script&lang=js&"
export * from "./SeaLogistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports